/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PatientCensus = {
    properties: {
        id: {
    type: 'number',
    isReadOnly: true,
    format: 'int64',
},
        company_id: {
    type: 'number',
    isRequired: true,
    format: 'int64',
},
        census_date: {
    type: 'string',
    isRequired: true,
    format: 'date',
},
        census: {
    type: 'number',
    isRequired: true,
},
        created_at: {
    type: 'string',
    isReadOnly: true,
    format: 'date-time',
},
        updated_at: {
    type: 'string',
    isReadOnly: true,
    format: 'date-time',
},
    },
};